import React from "react";
import {
  ProcessCardContainer,
  ProcessCardParagraph,
  ProcessCardParagraphText,
  ProcessCardImage,
  ProcessCardBadges,
  ProcessCardBadge,
  ProcessImageCardContainer,
  ProcessCardHeader,
  //Bold,
} from "./ProcessCard.styled";
//import { Trans } from "react-i18next";
import PropTypes from "prop-types";
import ProcessArrow from "../ProcessArrow/ProcessArrow";
import { useTranslation, Trans } from "react-i18next";

const ProcessCard = (props) => {
  const { t } = useTranslation();
  return (
    <ProcessCardContainer>
      <ProcessImageCardContainer>
        {props.image && (
          <ProcessCardImage $height={"180px"} $color={props.color}>
            {props.image}
          </ProcessCardImage>
        )}
        <ProcessArrow
          color={props.color}
          length={props.arrowLenght}
          showArrowhead={props.showArrowhead}
          dashArray={props.dashArray}
        />
      </ProcessImageCardContainer>
      <ProcessCardParagraph $color={props.color}>
        {props.header && (
          <ProcessCardHeader $color={props.color}>
            {props.header}
          </ProcessCardHeader>
        )}
        <ProcessCardParagraphText>
          <Trans t={t} i18nKey={props.text} />
        </ProcessCardParagraphText>
        <ProcessCardBadges>
          {props.badges &&
            props.badges.map((item, index) => (
              <ProcessCardBadge key={index} $color={props.color}>
                {item}
              </ProcessCardBadge>
            ))}
        </ProcessCardBadges>
      </ProcessCardParagraph>
    </ProcessCardContainer>
  );
};

ProcessCard.propTypes = {
  children: PropTypes.node,
  image: PropTypes.node,
  text: PropTypes.string,
  header: PropTypes.string,
  color: PropTypes.string,
  badges: PropTypes.array,
  arrowLenght: PropTypes.string,
  showArrowhead: PropTypes.bool,
  dashArray: PropTypes.string,
};

ProcessCard.defaultProps = {
  textColor: "white",
  IsEvenRow: false,
  arrowLenght: "190",
};

export default ProcessCard;
